module.exports = __webpack_public_path__ + "img/newsdetails2.f6d21baf.png";